import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const useTireCategories = createQueryStringToggleHook("tire-tag", []);
